import { DuviCoreAdminAppShell } from "../../components/duvi-core-admin-app-shell";
import { useDuviCoreAdminUserDetail } from "./use-duvi-core-admin-user-detail";
import { DuviCoreAdminUserDetailView } from "./duvi-core-admin-user-detail-view";

export function DuviCoreAdminUserDetail() {
  const state = useDuviCoreAdminUserDetail();

  return (
    <DuviCoreAdminAppShell
      title={state.user?.name ?? "User"}
      subtitle="Account profile and security"
      breadcrumbs={["Platform", "Users", state.user?.name ?? "Loading…"]}
      headerBreadcrumbs={[
        { label: "Users", href: "/user-management" },
        { label: "Profile" },
      ]}
      activeMenuItem="Users"
    >
      <DuviCoreAdminUserDetailView {...state} />
    </DuviCoreAdminAppShell>
  );
}
